import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EventDetails } from "@/components/site/EventDetails";
import { Manifesto } from "@/components/site/Manifesto";
import { Timeline } from "@/components/site/Timeline";
import { MarqueeBand } from "@/components/site/MarqueeBand";
import { RegistrationForm } from "@/components/site/RegistrationForm";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    document.title = "Benefizanlass · JCI FRZ Social Impact × Stiftung Chance";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain min-h-screen bg-ink" data-testid="app-root">
        <Toaster position="top-center" richColors />
        <Nav />
        <main>
          <Hero />
          <EventDetails />
          <Manifesto />
          <Timeline />
          <MarqueeBand />
          <RegistrationForm />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
